import GiftLogin from "components/Auth/Gift-login"
import GiftsignUp from "components/Auth/GiftsignUp"
import SkylifeSuccess from "components/Auth/skylife_success"
import Thankyou from "components/Auth/thankyou"

import TrialForget from "components/Auth/trial-forget"
import TrialReset from "components/Auth/trial-reset"
import TrialSuccess from "components/Auth/trial-success"
import { pathApp } from "services/utiles"


const PublicRoutesTrial = [
  { path: `/trial-signup`, name: "GiftsignUp", exact: true, component: GiftsignUp },
  { path: `/trial-login`, name: "GiftLogin", exact: true, component: GiftLogin },

  { path: `/trial/forgot-password`, name: "TrialForget", component: TrialForget },
  { path: `/trial/reset`, name: "Dashboard", component: TrialReset },
  { path: `/trial-success`, name: 'Dashboard', component: TrialSuccess },
  // { path: `/trial-success2`, name: 'trial-success', component: SkylifeSuccess },
  { path: `/trial-influencer-success`, name: 'trial-in-success', component: SkylifeSuccess },
  { path: `/trial-thankyou`, name: 'trial-Thankyou', component: Thankyou },





  // trial-influencer-success

]
export default PublicRoutesTrial